/**
 * Export a deck's chosenCards to the Curiosa bulk-import text format.
 *
 * Format: one card per line, "quantity name." No zone headers, no
 * "Avatar:" prefix. Curiosa's importer only accepts the plain
 * quantity+name format and rejects anything else.
 *
 * Foiling is ignored (Curiosa doesn't track it). Duplicate printings
 * of the same card name are collapsed and their quantities summed.
 *
 * Example output:
 *   1 Sensu of the Fang
 *   4 Cave Trolls
 *   2 Plague Rat
 *   2 River Rapids
 *   1 Ghoul
 */
export function exportDeckToCuriosa(chosenCards) {
  if (!Array.isArray(chosenCards) || chosenCards.length === 0) return '';

  const counts = new Map();
  for (const entry of chosenCards) {
    const name = entry.card?.name || entry.cardName;
    if (!name) continue;
    const zone = entry.zone || (entry.isSideboard ? 'collection' : 'spellbook');
    if (zone === 'avatar') continue;
    counts.set(name, (counts.get(name) || 0) + 1);
  }

  const lines = [];
  for (const [name, qty] of counts) {
    lines.push(`${qty} ${name}`);
  }
  return lines.join('\n');
}

export async function copyDeckToClipboard(chosenCards) {
  const text = exportDeckToCuriosa(chosenCards);
  await navigator.clipboard.writeText(text);
  return text;
}
